import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductsRoutingModule } from './products-routing.module';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductCreateComponent } from './product-create/product-create.component';
import { ProductEditComponent } from './product-edit/product-edit.component';
import { ProductFilterComponent } from './product-filter/product-filter.component';
import {GridModule} from '@syncfusion/ej2-angular-grids';
import {DateRangePickerModule} from '@syncfusion/ej2-angular-calendars';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SwitchModule} from '@syncfusion/ej2-angular-buttons';
import {FormsModule} from '@angular/forms';
import {ControlsModule} from '../controls/controls.module';
import {ListViewModule} from '@syncfusion/ej2-angular-lists';
import {ToastModule} from '@syncfusion/ej2-angular-notifications';
import {FileUploadModule} from 'ng2-file-upload';


@NgModule({
  declarations: [ProductListComponent, ProductCreateComponent, ProductEditComponent, ProductFilterComponent],
  imports: [
    CommonModule,
    ProductsRoutingModule,
    GridModule,
    DateRangePickerModule,
    NgbModule,
    SwitchModule,
    FormsModule,
    ControlsModule,
    ListViewModule,
    ToastModule,
    FileUploadModule
  ]
})
export class ProductsModule { }
